  function openOfficialCslbLinksInNewTab(root) {
    root.querySelectorAll('.product__description a[href]').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.href);
        var hostname = url.hostname.toLowerCase();
        var isOfficialCslbLink = hostname === 'cslb.ca.gov' || hostname.endsWith('.cslb.ca.gov');

        if (!isOfficialCslbLink) return;

        link.target = '_blank';

        var relValues = new Set((link.rel || '').split(/\s+/).filter(Boolean));
        relValues.add('noopener');
        relValues.add('noreferrer');
        link.rel = Array.from(relValues).join(' ');
      } catch (error) {
        // Leave malformed product-description links unchanged.
      }
    });
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var thumbnail = event.target.closest('[data-product-gallery-thumbnail]');
    if (!thumbnail || thumbnail.getAttribute('aria-pressed') === 'true') return;

    var gallery = thumbnail.closest('[data-product-gallery]');
    var mainImage = gallery && gallery.querySelector('[data-product-gallery-main]');
    if (!mainImage) return;

    var previewImage = thumbnail.querySelector('img');
    mainImage.removeAttribute('srcset');
    mainImage.src = previewImage.currentSrc || previewImage.src;
    mainImage.alt = thumbnail.dataset.imageAlt;
    mainImage.width = Number(thumbnail.dataset.imageWidth);
    mainImage.height = Number(thumbnail.dataset.imageHeight);

    gallery.querySelectorAll('[data-product-gallery-thumbnail]').forEach(function (button) {
      button.setAttribute('aria-pressed', button === thumbnail ? 'true' : 'false');
    });

    var fullImage = new Image();
    fullImage.onload = function () {
      var showFullImage = function () {
        if (thumbnail.getAttribute('aria-pressed') === 'true') {
          mainImage.src = fullImage.src;
        }
      };
      if (fullImage.decode) {
        fullImage.decode().then(showFullImage, showFullImage);
      } else {
        showFullImage();
      }
    };
    fullImage.src = thumbnail.dataset.imageSrc;
  });

  openOfficialCslbLinksInNewTab(document);

  document.addEventListener('shopify:section:load', function (event) {
    openOfficialCslbLinksInNewTab(event.target);
  });
